import { MealGroup } from '@/plugins/api'

/**
 * Store nhóm đối tượng đăng ký ăn.
 * fetchList dùng fetchMealGroup (kèm số học sinh mỗi nhóm).
 */
export default {
  namespaced: true,
  state: {
    groups: [],
    totalItems: 0,
    itemsPerPage: 10,
    pageText: '',
    loading: false,
    searchParams: {}
  },
  actions: {
    async fetchList({ commit, state }, { page = 1, itemsPerPage, ...query } = {}) {
      commit('changeState', { loading: true })
      const limit = itemsPerPage || state.itemsPerPage
      const params = { ...query, _start: (page - 1) * limit, _limit: limit, _sort: 'title:ASC' }
      const [totalItems, groups] = await Promise.all([
        MealGroup.count(query),
        MealGroup.fetchMealGroup(params)
      ])
      const pageStop = Math.min(page * limit, totalItems)
      commit('changeState', {
        groups,
        totalItems,
        itemsPerPage: limit,
        searchParams: query,
        pageText: `${(page - 1) * limit + 1}-${pageStop} trên ${totalItems}`,
        loading: false
      })
    },
    async fetchOne(_, id) {
      return MealGroup.fetchOne(id)
    },
    async create(_, data) {
      return MealGroup.create(data)
    },
    async update(_, { id, ...data }) {
      return MealGroup.update(id, data)
    },
    async remove(_, id) {
      return MealGroup.remove(id)
    }
  },
  mutations: {
    changeState(state, obj) {
      Object.assign(state, obj)
    }
  }
}
